import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll84enMxZGgwIHsKICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1fMWttbG1nNTcpOwogIHBhZGRpbmc6IDEwcHggMTVweDsKICBtYXJnaW4tYm90dG9tOiAxNnB4Owp9';
export var errorContainer = '_8zs1dh0';